import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@material-ui/core';
import { ErrorOutline } from '@material-ui/icons';

const S = {
  Content: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
  Paragraph: styled.p`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: ${({ marginBottom }) => marginBottom};
    color: ${({ theme }) => theme.palette.grey[900]};
    font-size: 1rem;
    line-height: 1.5;
    text-align: center;
  `,
  Button: styled(Button)`
    margin-bottom: 0.75rem;
  `,
  ErrorOutline: styled(ErrorOutline)`
    margin-bottom: 1.5rem;
    color: ${({ theme }) => theme.palette.grey[300]};
    font-size: 7.5rem;
  `,
};

const OpenLinkError = ({ onRetry }) => (
  <S.Content>
    <S.ErrorOutline />
    <S.Paragraph marginBottom="4rem">
      에러가 발생했습니다.
      <br />
      잠시 후 다시 시도해주세요.
    </S.Paragraph>
    <S.Button
      type="button"
      variant="outlined"
      onClick={onRetry}
    >
      다시 시도
    </S.Button>
  </S.Content>
);

OpenLinkError.propTypes = {
  onRetry: PropTypes.bool.isRequired,
};

export default OpenLinkError;
